import { service } from "@/api/service ";
import { toastError, toast } from "@/components/custom/Toast";
//import store from "../..";

const state = {
  conditions: [],
  condition: {},
  pagination: {},
  addStatus: false,
  editStatus: false,
  deleteStatus: false,
  tables: [],
  fields: [],
};
const getters = {
  conditionsListGet: (state) => state.conditions,
  conditionGet: (state) => state.conditions,
  tablesGet: (state) => state.tables,
  fieldsGet: (state) => state.fields,
};
const actions = {
  async getConditions({ commit }) {
    const result = await service.getFun(`conditions`);
    if (result) {
      commit("conditionsListSet", result.data);
    }
  },
  async getTables({ commit }) {
    const result = await service.getFun(`gettables`);
    if (result) {
      commit("tablesListSet", result.data.Tables);
    }
  },
  async getFields({ commit }) {
    const result = await service.getFun(`getCoulmns/`);
    if (result) {
      commit("fieldsListSet", result.data);
    }
  },
  addCondition({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `conditions`, null, {
        action: "getConditions",
      })
      .then(
        (result) => {
          commit("addConditionStatus", result.success);
          toast(result.message);
        },
        (error) => {
          console.log("conditions..." + error);
          toastError(error);
        }
      );
  },
  editCondition({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `conditions/${payload.id}`,
        null,
        {
          action: "getConditions",
        }
      )
      .then(
        (result) => {
          if (result) {
            commit("editConditionStatus", result.success);
            toast(result.message);
          } else {
            commit("editConditionStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  async deleteCondition({ commit }, payload) {
    console.log(payload, "payload");
    const result = await service.deleteFun(`conditions/${payload?.payload}`, {
      action: "getConditions",
    });
    if (result) {
      commit("deleteConditionStatus", result?.success);
      toast(result?.message);
    }
  },
};
const mutations = {
  conditionsListSet(state, conditions) {
    state.conditions = conditions;
  },
  tablesListSet(state, tables) {
    state.tables = tables;
  },
  fieldsListSet(state, fields) {
    state.fields = fields;
  },
  addConditionStatus(state, Status) {
    state.addStatus = Status;
  },
  editConditionStatus(state, Status) {
    state.editStatus = Status;
  },
  deleteConditionStatus(state, Status) {
    state.deleteStatus = Status;
  },
  // setPagination(state, pageResult) {
  //   state.pagination = pageResult;
  // },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
